module.exports = __webpack_public_path__ + "static/media/meritus-4.888f3f66.jpg";